module.exports = __webpack_public_path__ + "static/media/axe-battle.cd588cb2.svg";